/**
 * 验厂隐藏模式下元素不可见
 * @Example v-hidden
 */
import type { Directive } from 'vue';
import { getGlobalStore } from '@/store';

const hiddenDirective: Directive = {
  mounted: (el: Element) => {
    getGlobalStore().getCheckHidden && el.parentNode?.removeChild(el);
  },
};

export default hiddenDirective;
